import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CustomerInterface } from '@monsido/modules/models/api/interfaces/customer.interface';
import { DomainManagementSharedService } from '../../services/domain-management-shared.service';

@Component({
    selector: 'mon-domain-import-dropdown',
    templateUrl: './import-dropdown.component.html',
    standalone: false,
})
export class DomainImportDropdownComponent {
    @Input() customer: CustomerInterface;
    @Input() monIsBackendAdmin: boolean = false;

    @Output() csvImportRequested = new EventEmitter<void>();
    @Output() jsonImportStarted = new EventEmitter<void>();
    @Output() jsonImportCompleted = new EventEmitter<void>();
    @Output() jsonImportFailed = new EventEmitter<string>();

    constructor (
        private sharedService: DomainManagementSharedService,
    ) {}

    onCsvImport (): void {
        this.csvImportRequested.emit();
    }

    onJsonImport (): void {
        this.sharedService.openJsonImportWizard(
            this.customer,
            this.monIsBackendAdmin,
            () => this.jsonImportStarted.emit(),
            () => this.jsonImportCompleted.emit(),
            (error) => this.jsonImportFailed.emit(error),
        );
    }
}
